/**
 * Делит входной плоский массив на чанки
 *
 * @param arr Входной массив (н-р: [1, 2, 3, 4, 5, 6])
 * @param chunkSize Размер чанков (н-р: 3)
 * @returns [[1, 2, 3], [4, 5, 6]]
 */
export function getArrayChunks<A>(arr: A[], chunkSize: number): A[][] {
  const result = [];

  for (let i = 0; i < arr.length; i += chunkSize) {
    result.push(arr.slice(i, i + chunkSize));
  }

  return result;
}
